import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import DateTimePicker_Dsas from '../../../../../dsasComponents/DateTimePicker_Dsas.js';
import useStyles from '../../../../../styles/global-mui.js';
import { discipline_actu_all } from '../../../../../bdd/bddSTUB.js';
import { isAdminDSAS } from '../../../../../actions/auth.js';
import SelectGroupProvider from '../../../../../dsasComponents/SelectGroupProvider.js';
import SelectMultiUser from '../../../../../dsasComponents/SelectMultiUser.js';
import DsasButton from '../../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowRotateRight, faCancel, faCheck } from '@fortawesome/free-solid-svg-icons';
import { usePermissions } from '../../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';



const LivePopupCreator = ({open, setOpen, state, setState, handleConfirm, handleCancel, handleClear}) => {
    const classes = useStyles();

      const { getPermission } = usePermissions();
      const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

      const handleChangeName = (e) => {
        setState(s => ({...s, name : e.target.value}))
      }

      const handleChangeDateTime = (value) => {
        let targetName = "dateTime"
        setState(s => ({...s, [targetName]: value}))
    }

          const isValidUrlName = (value) => {
        // Autorise lettres (avec accents), chiffres, espace, tiret, underscore, point
        const regex = /^[\p{L}\p{N}._\- ]+$/u;
        return regex.test(value);
      };

      const hasUsers = Array.isArray(state.userNames) && state.userNames.length > 0;


      return (
            <Dialog open={open} fullWidth maxWidth={"lg"}>
              <Box className='centered-wrapper padding-wrapper'>
                <Typography variant="h1" className='page-title'>Création de direct</Typography>
              </Box>
              
              <Box className='large-separator'></Box>
      
                {/**POPUP BODY CONTENT*/}
                  <DialogContent sx={{padding:'2rem'}}>

                    <Grid container spacing={1.5}>
                                <Grid item xs={12} sm={8} md={8}>
                                  {/* Live name */}
                                  <TextField
                                    className={classes.customInput}
                                    name="lastname"
                                    variant="outlined"
                                    label="Nom"
                                    fullWidth
                                    value={state.name}
                                    onChange={(e) => {
                                      setState((s) => ({ ...s, name: e.target.value }));
                                    }}
                                    helperText={
                                      state.name && !isValidUrlName(state.name)
                                        ? "Caractères spéciaux non autorisés"
                                        : ''
                                    }
                                    error={state.name && !isValidUrlName(state.name)}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                  {/* Live category */}
                                  <FormControl fullWidth className={classes.customInput} >
                                  <InputLabel id={"disciplinecompet"}>Catégorie</InputLabel>
                                  <Select 
                                      labelId={'disciplinecompet'}
                                      id={"disciplinecompetselect"}
                                      name={'discipline'}
                                      value={state.discipline}
                                      label={'Catégorie'}
                                      onChange={(e) => setState(s => ({...s, discipline : e.target.value}))}
                                  >
                                      {discipline_actu_all && discipline_actu_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                                  </Select>
                              </FormControl>
                                </Grid>
                            </Grid>  
                    
                            <Box className='medium-padding'></Box>
                    
                            <Grid container spacing={1.5} alignItems="center">
                                <Grid item xs={12} sm={3} md={3}>
                                   {/* Live date */}
                                  <DateTimePicker_Dsas className={classes.customInput}
                                                      label={"Début du direct"}
                                                      name={"dateTime"}
                                                      value={state.dateTime}
                                                      onChange = {handleChangeDateTime}
                                  />
                                </Grid>
                               {providerPermission?.allowed && (
                                <Grid item xs={12} sm={3} md={3}>
                                  {/* Group */}
                                    <FormControl fullWidth 
                                      className={classes.customInput}
                                      variant="standard" 
                                      margin="normal"
                                      sx={{marginTop:0}}
                                      >
                                      <SelectGroupProvider value={state.provider} onChange={(e) => setState(s => ({...s, provider : e.target.value, userNames: [] }))}/>
                                    </FormControl>            
                                </Grid>)}


                                <Grid item xs={12} sm md>
                                  {/* Users */}
                                   <SelectMultiUser handleChangeUsers={(users) => setState(s => ({...s, userNames : users}))} usersSelected={state.userNames} provider={state.provider} autoSelect={false}></SelectMultiUser>
                                </Grid>


                            </Grid>

                    {(!state || !state.name || !state.discipline || state.userNames?.length===0)  &&
                        <Box className='centered-wrapper medium-padding'>
                          <Typography variant='body2' sx={{ fontStyle: 'italic' }} >Veuillez indiquer un nom, une catégorie et au moins un utilisateur pour enregistrer votre direct.</Typography>
                        </Box>
                    }


                  </DialogContent>
      
                  <Box className='large-separator'></Box>
                  <DialogActions sx={{justifyContent:'center'}}>
                  <Box className='centered-wrapper'>
                    <DsasButton icon={faArrowRotateRight} label="Reset" onClick={handleClear} variant = 'secondary'/>
                    <DsasButton icon={faCancel} label="Annuler" onClick={() => {
                            handleCancel();
                          }} variant = 'secondary'/>
                    <DsasButton
                      icon={faCheck}
                      label='Enregistrer le direct'
                      onClick={handleConfirm}
                      disabled={
                        !state.name ||
                        !isValidUrlName(state.name) ||
                        !state.discipline||
                        !hasUsers
                      }
                      variant='secondary'
                    />
                  </Box>
                  </DialogActions>
              </Dialog>
          )
      
}

export default LivePopupCreator